export default __webpack_public_path__ + "static/media/NotoSerif-Bold.7827fa14.woff";